import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TFetchHostProfileError, THostProfileErrorCode } from 'shared/types/onlineBookingProfile/fetchHostProfileData';

import type { IPublicV1PageDataHostProfileResponse } from 'shared/repositories/dailyrent/entities/response/PublicV1PageDataHostProfileResponse';
import { getErrorCode } from 'shared/utils/apiErrors';

type THostProfileStatus = 'idle' | 'loading' | 'success' | 'error';

export interface IHostProfileState {
  status: THostProfileStatus;
  data: IPublicV1PageDataHostProfileResponse | null;
  errorCode: THostProfileErrorCode | null;
}

export const initialState: IHostProfileState = {
  status: 'idle',
  data: null,
  errorCode: null,
};

const hostProfileSlice = createSlice({
  name: 'hostProfile',
  initialState,
  reducers: {
    setHostProfileData(state, action: PayloadAction<IPublicV1PageDataHostProfileResponse>) {
      state.status = 'success';
      state.data = action.payload;
      state.errorCode = null;
    },
    setHostProfileError(state, action: PayloadAction<TFetchHostProfileError>) {
      state.status = 'error';
      state.data = null;
      if (action.payload.type === 'api') {
        state.errorCode = getErrorCode(action.payload.data);
      } else {
        state.errorCode = 'unknown';
      }
    },
    resetHostProfile: () => initialState,
  },
});

export const {
  reducer: hostProfileReducer,
  actions: { setHostProfileData, setHostProfileError, resetHostProfile },
} = hostProfileSlice;
